import type { DRDrawingViewer } from "../DRDrawingViewer";
import { BaseAddEntityCommand } from "./BaseAddEntityCommand";

export interface AddEntitiesParams {
  /** Handles of the entities (stable identifiers) */
  entityHandles: string[];
  /** The original layer name to restore on redo */
  originalLayerName: string;
}

/**
 * Command for adding multiple entities (e.g., shape + hatch) with soft-delete undo.
 * All entities are treated as a single undo/redo operation.
 */
export class AddEntitiesCommand extends BaseAddEntityCommand {
  constructor(viewer: DRDrawingViewer, params: AddEntitiesParams) {
    super(viewer, {
      entityHandles: params.entityHandles,
      originalLayerName: params.originalLayerName,
    });
  }
}
